import React, { useState, useEffect } from "react";
import { Paginator } from "../../../../layout/Paginator/Paginator";
import { Search } from "../../../../layout/Table/Search";
import { TableComponent } from "./groupsTable/Table";
import { CreateGroup } from "./groupsTable/actionButtons/CreateGroup";
import { NOTIFICATION_CREATE_ADMIN_GROUP } from "../../../../../config/notifications";
import { Messages } from '../../../../layout/Messages/Messages';
import { ACL } from '../../../../../config/constants';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';
import { RowsPerPage } from "../../../../layout/Table/RowsPerPage";
import { ListToolbar } from '../../../../layout/Workspace';

function GroupsTab(props) {
  const [ sortDirection, setSortDirection ] = useState( null );
  const [ sortField, setSortField ] = useState( null );
  const [ searchText, setSearchText ] = useState( null );
  const { groups, metaGroups, getGroups, rowsPerPageGroups, setRowsPerPageGroups } = props;

  useEffect(() => {
    return () => {
      store.dispatch(hideNotification());
    }
  }, []);

  useEffect( () => {
    if (getGroups) {
      getGroups( 1, sortField, sortDirection, searchText );
    }

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPageGroups] );

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField( appliedSortField );
    setSortDirection( newSortDirection );

    getGroups( metaGroups.current_page, appliedSortField, newSortDirection, searchText, true );
  }

  return (
    <div className="admin-management-tab-content">
        <div className="admin-management-panel-notifications">
          <Messages notificationId={NOTIFICATION_CREATE_ADMIN_GROUP}/>
        </div>
        <ListToolbar
          actions={<CreateGroup actionCallback={getGroups}/>}
          className="admin-management-toolbar"
          search={ACL.ADMIN.GROUPS.LIST.hasAccess() && ACL.ADMIN.GROUPS.SEARCH.hasAccess() ? <Search
              search={(searchText) => {
                setSearchText( searchText );
                getGroups( 1, null, null, searchText, true );
              }}
              id="groups"
            /> : null}
        />
        <div className="admin-management-table">
          <TableComponent
            applySort={(sortField) => applySort( sortField )}
            groups={groups}
            actionCallback={(useState) => {
              if (useState) {
                getGroups(
                  metaGroups.current_page,
                  sortField,
                  sortDirection,
                  searchText
                );
              } else {
                getGroups();
              }
            }}
          />
        </div>
        <div className="admin-management-pagination">
          <Paginator
            meta={metaGroups}
            settings={(
              <RowsPerPage
                changeRowsPerPage={(rowsPerPage) => {
                  setRowsPerPageGroups(rowsPerPage);
                }}
                id="groups"
              />
            )}
            changePage={(page) =>
              getGroups( page, sortField, sortDirection, searchText, true )
            }
          />
        </div>
    </div>
  );
}

export { GroupsTab };
